// extracted by mini-css-extract-plugin
module.exports = {"Container":"good-deal-brand_Container__6uW15","Small":"good-deal-brand_Small__VgTuq"};